import React from 'react'

const FrontCard = (props) => {
  return (
    <div style={styles.flexItem}>
      <h1 style={styles.jumbotronParagraph}>{props.title}</h1>
    </div>
  )
}

const styles = {
  flexItem: {
    width: '300px',
    margin: '10px',
    textAlign: 'center',
    height: '160px',
    border: '1px black solid',
    backgroundColor: '#DAAD86',
    padding: '5px',
    boxShadow: '5px 10px 18px black',
    color: 'black',
    borderRadius: '25px'
  },
  jumbotronParagraph: {
    lineHeight: '20px',
    padding: '40px'
  }
}

export default FrontCard
